import { render, staticRenderFns } from "./AdminVendorForm.vue?vue&type=template&id=b91217ae"
import script from "./AdminVendorForm.vue?vue&type=script&lang=ts"
export * from "./AdminVendorForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports